<template lang='pug'>
.max-wrapper
  login-skeleton(v-if="fetching")
  template(v-else)
    h1(v-if="!$rogue.appContext") {{__('Log In or Create an Account')}}
    suspense
      template(#default)
        .forms
          login(:showCaptchaBlurb="false").form
          .separator
          .form
            register.form(v-if="!$rogue.appContext")
            captcha-blurb
      template(#fallback)
        login-forms-skeleton
</template>

<script lang="ts" setup>
import { onMounted, computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'
import metadata from '@/js/helpers/metadata'
import { useRogue } from '@/js/services/Rogue'
import { useCustomerStore } from '@/js/stores/customerStore'
import CaptchaBlurb from '../../components/login/captcha-blurb.vue'
import LoginSkeleton from './components/login-skeleton.vue'
import LoginFormsSkeleton from './components/login-forms-skeleton.vue'

const route = useRoute()
const router = useRouter()
const rogue = useRogue()
const customerStore = useCustomerStore()

useHead(metadata({ title: rogue.__('Log In'), url: `${rogue.localizedBaseURL}${route.path}` }, rogue))

const fetching = ref(true)
const loggedIn = computed(() => customerStore.loggedIn)

onMounted(async () => {
  await customerStore.init(rogue)

  if (loggedIn.value) {
    router.replace('/account/dashboard').catch(() => {})
  }

  fetching.value = false
})
</script>

<style lang="scss" scoped>
.forms {
  @include not-mobile() {
    display: flex;
  }
}

.separator {
  width: 1px;
  flex-shrink: 0;
  margin: 0 $space-m;
  align-self: stretch;
  height: $space-m;

  @include not-mobile() {
    height: auto;
    background-color: $color-gray-light;
    display: block;
  }

  @include large-xl() {
    margin: 0 $space-xxxl;
  }
}

.form {
  flex: 1;
  flex-basis: 50%;
}

</style>
